/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputAlternativeChannel } from './OutputAlternativeChannel';
import {
    OutputAlternativeChannelFromJSON,
    OutputAlternativeChannelFromJSONTyped,
    OutputAlternativeChannelToJSON,
} from './OutputAlternativeChannel';

/**
 * 
 * @export
 * @interface OutputAlternativeChannelsResponse
 */
export interface OutputAlternativeChannelsResponse {
    /**
     * 
     * @type {Array<OutputAlternativeChannel>}
     * @memberof OutputAlternativeChannelsResponse
     */
    channel1Alternatives: Array<OutputAlternativeChannel>;
    /**
     * 
     * @type {Array<OutputAlternativeChannel>}
     * @memberof OutputAlternativeChannelsResponse
     */
    channel2Alternatives?: Array<OutputAlternativeChannel>;
}

/**
 * Check if a given object implements the OutputAlternativeChannelsResponse interface.
 */
export function instanceOfOutputAlternativeChannelsResponse(value: object): boolean {
    if (!('channel1Alternatives' in value)) return false;
    return true;
}

export function OutputAlternativeChannelsResponseFromJSON(json: any): OutputAlternativeChannelsResponse {
    return OutputAlternativeChannelsResponseFromJSONTyped(json, false);
}

export function OutputAlternativeChannelsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAlternativeChannelsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'channel1Alternatives': ((json['channel1Alternatives'] as Array<any>).map(OutputAlternativeChannelFromJSON)),
        'channel2Alternatives': json['channel2Alternatives'] == null ? undefined : ((json['channel2Alternatives'] as Array<any>).map(OutputAlternativeChannelFromJSON)),
    };
}

export function OutputAlternativeChannelsResponseToJSON(value?: OutputAlternativeChannelsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'channel1Alternatives': ((value['channel1Alternatives'] as Array<any>).map(OutputAlternativeChannelToJSON)),
        'channel2Alternatives': value['channel2Alternatives'] == null ? undefined : ((value['channel2Alternatives'] as Array<any>).map(OutputAlternativeChannelToJSON)),
    };
}

